import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

import {UseGetHealthDistrictsQueryProps} from './types';
import {getHealthDistricts} from '../../services/getHealthDistricts';

export function useGetHealthDistrictsQuery({params, enabled}: UseGetHealthDistrictsQueryProps) {
	return useQuery({
		queryKey: [QUERY_KEYS.DISTRICTS_HEALTH, params],
		queryFn: ({signal}) => getHealthDistricts({signal, ...params}),
		enabled,
	});
}
